<template>
  <div class="my-order-goods">
    <template v-if="new_list.length">
      <div class="m-order-goods">
        <div
          class="m-order-goods-item"
          v-for="(item, index) in new_list"
          :key="index"
        >
          <el-image
            class="m-order-goods-gallery"
            :src="item.thumbnail"
            :fit="'contain'"
          ></el-image>
          <div class="m-order-goods-info">
            <span class="m-order-goods-name">{{ item.title }}</span>
            <span class="m-order-goods-attr">{{ item.item_key_name }}</span>
            <div class="m-order-goods-qty">
              <span class="m-order-goods-price" v-if="!isIntegral">
                <em>￥</em>
                {{
                  item.price_type
                    ? item.price_type == 1
                      ? item.price
                      : item.price_type == 3
                      ? item.agreement_price
                      : item.prom_price
                    : item.price
                }}
              </span>
              <span class="m-order-goods-price" v-else>{{ item.price }}</span>
              <span class="m-order-goods-num">数量：x{{ item.num }}</span>
            </div>
          </div>
        </div>
        <div
          class="m-order-goods-more"
          @click="btnClick($event)"
          v-if="list.length > maxinum"
        >
          {{ isExpand ? "收起" : "展开" }}商品&gt;&gt;&gt;
        </div>
      </div>
      <div class="m-order-item-bottom" v-if="isShowTotal">
        <div class="m-order-goods-total-box">
          <div class="m-order-goods-total">
            共{{ list.length }}计&nbsp;&nbsp;总计金额：
            <span class><em>￥</em>{{ total_amount }}</span>
          </div>
          <span class="m-order-freight">含运费：{{ freight_amount }}</span>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="m-skeleton">
        <el-skeleton :rows="3"></el-skeleton>
      </div>
      <div class="m-skeleton" v-if="isShowTotal">
        <el-skeleton :rows="1"></el-skeleton>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isExpand: false,
      maxinum: 3,
    };
  },
  props: {
    isShowTotal: {
      type: Boolean,
      default: true,
    },
    list: [],
    isIntegral: false,
    total_amount: 0, //总计
    freight_amount: 0, //运费
  },
  computed: {
    new_list() {
      const { list, isExpand, maxinum } = this;
      return isExpand ? list : list.slice(0, maxinum);
    },
  },
  methods: {
    btnClick(ev) {
      const { isExpand } = this;
      ev.stopPropagation();
      this.isExpand = !isExpand;
    },
  },
};
</script>

<style>
.m-order-goods-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-around;
  width: 100%;
  margin-left: 0.2rem;
}
.m-order-goods-qty {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.m-order-goods-attr {
  color: #898989;
}
.m-order-goods-name {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  font-weight: bold;
}
.m-order-goods-gallery {
  border: 1px solid #f1f1f1;
  border-radius: 0.2rem;
  width: 2rem;
  height: 2rem;
  flex-shrink: 0;
}
.m-order-goods-item {
  padding: 0.2rem 0;
  margin-top: 0.1rem;
  border: 1px solid #f1f1f1;
  border-left: 0;
  border-right: 0;
  display: flex;
}
.m-order-goods-item:not(:first-child) {
  margin-top: 0;
  border-top: 0;
}
.m-order-goods-total-box {
  padding: 0.2rem 0;
  padding-bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.m-order-goods-total {
  font-weight: bold;
}
.m-order-goods-total span {
  color: #f00;
  font-weight: bold;
  font-size: 0.32rem;
}
.m-order-goods-total span>em{
  font-size: 0.26rem;
}
.m-order-goods-more {
  display: block;
  text-align: center;
  padding: 0.2rem;
  color: #898989;
}
.m-order-goods-price {
  color: #f00;
  font-weight: bold;
  font-size: 0.28rem;
}
.m-order-goods-price em {
  font-size: 0.2rem;
}
.m-skeleton {
  background-color: #fff;
  padding: 0.2rem;
}

.m-skeleton + .m-skeleton {
  margin-top: 0.1rem;
}

.m-skeleton .el-skeleton {
  text-align: left;
}

.m-skeleton .el-skeleton__item {
  margin-top: 0.1rem;
}
</style>


// WEBPACK FOOTER //
// src/pages/mobile/components/MyOrderGoods/index.vue